/** 6×6 die lines for square browse cards (replaces the old 9×4 landscape overlay). */

export const JIGSAW_BROWSE_DIE_LINE_GRID = 6;
export const JIGSAW_BROWSE_DIE_LINE_VIEWBOX = { width: 1536, height: 1536 };

function mulberry32(seed) {
    return function next() {
        let t = (seed += 0x6d2b79f5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

function fmt(n) {
    return (Math.round(n * 100) / 100).toFixed(2);
}

/** Three cubics from (x0,y) → (x1,y) with a jigsaw tab (matches play-template die style). */
function horizontalTab(x0, x1, y, dir, rnd) {
    const cell = x1 - x0;
    const amp = cell * (0.24 + rnd() * 0.05) * dir;
    const m = x0 + cell * (0.38 + rnd() * 0.12);
    const w = cell * (0.14 + rnd() * 0.04);
    const yTab = y + amp;
    return [
        `C ${fmt(x0 + cell * 0.2)} ${fmt(y + amp * 0.08)} ${fmt(m - w)} ${fmt(y + amp * 0.35)} ${fmt(m - w)} ${fmt(yTab)}`,
        `C ${fmt(m - w)} ${fmt(yTab + amp * 0.42)} ${fmt(m + w)} ${fmt(yTab + amp * 0.42)} ${fmt(m + w)} ${fmt(yTab)}`,
        `C ${fmt(m + w)} ${fmt(y + amp * 0.35)} ${fmt(x1 - cell * 0.2)} ${fmt(y - amp * 0.06)} ${fmt(x1)} ${fmt(y)}`,
    ].join(" ");
}

function verticalTab(x, y0, y1, dir, rnd) {
    const cell = y1 - y0;
    const amp = cell * (0.24 + rnd() * 0.05) * dir;
    const m = y0 + cell * (0.38 + rnd() * 0.12);
    const w = cell * (0.14 + rnd() * 0.04);
    const xTab = x + amp;
    return [
        `C ${fmt(x + amp * 0.08)} ${fmt(y0 + cell * 0.2)} ${fmt(x + amp * 0.35)} ${fmt(m - w)} ${fmt(xTab)} ${fmt(m - w)}`,
        `C ${fmt(xTab + amp * 0.42)} ${fmt(m - w)} ${fmt(xTab + amp * 0.42)} ${fmt(m + w)} ${fmt(xTab)} ${fmt(m + w)}`,
        `C ${fmt(x + amp * 0.35)} ${fmt(m + w)} ${fmt(x - amp * 0.06)} ${fmt(y1 - cell * 0.2)} ${fmt(x)} ${fmt(y1)}`,
    ].join(" ");
}

function buildJigsawBrowseDieLinePaths(grid, size) {
    const cell = size / grid;
    const rnd = mulberry32(6006);
    const hParts = [];
    for (let row = 1; row < grid; row += 1) {
        const y = row * cell;
        let d = `M 0,${fmt(y)}`;
        for (let col = 0; col < grid; col += 1) {
            const dir = (row + col) % 2 === 0 ? 1 : -1;
            d += ` ${horizontalTab(col * cell, (col + 1) * cell, y, dir, rnd)}`;
        }
        hParts.push(d);
    }
    const vParts = [];
    for (let col = 1; col < grid; col += 1) {
        const x = col * cell;
        let d = `M ${fmt(x)},0`;
        for (let row = 0; row < grid; row += 1) {
            const dir = (row + col) % 2 === 0 ? -1 : 1;
            d += ` ${verticalTab(x, row * cell, (row + 1) * cell, dir, rnd)}`;
        }
        vParts.push(d);
    }
    return [
        { key: 0, d: hParts.join(" ") },
        { key: 1, d: vParts.join(" ") },
    ];
}

export const JIGSAW_BROWSE_DIE_LINE_PATHS = buildJigsawBrowseDieLinePaths(
    JIGSAW_BROWSE_DIE_LINE_GRID,
    JIGSAW_BROWSE_DIE_LINE_VIEWBOX.width
);
